<template>
  <div class="sky-change-item-detail wsp-padding-left-12">
    <div class="page-content-loading sky-page-content" v-if="loading">
      <sk-icon-status type="ing" content="加载中..."></sk-icon-status>
    </div>
    <div v-else class="sky-page-content">
      <div>
        <div>
          <div class="wsp-sub-group-title">
            <div class="wsp-group-sub-title-icon"></div>
            <div class="wsp-group-sub-title-value">
              {{ specName }} （<span class="title-tip">注：红色背景代表有变化</span>）
            </div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div v-if="contentList && contentList.length > 0">
              <el-table
                :data="contentList"
                :border="true"
                :show-header="true"
                :cell-class-name="changeCellClassName"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-detail-content "
              >
                <el-table-column label="属性名称" header-align="center" prop="itemName" width="275">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.change" type="danger">{{ scope.row.itemName }}</el-tag>
                    <span v-else>{{ scope.row.itemName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="变更前" header-align="center" prop="beforeChange" />
                <el-table-column label="变更后" header-align="center" prop="afterChange" />
              </el-table>
            </div>

            <div v-if="relationList && relationList.length > 0">
              <el-table
                :data="relationList"
                :border="true"
                :show-header="true"
                header-align="center"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-detail-content "
              >
                <el-table-column label="关系名称" header-align="center" prop="itemName" width="275">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.change" type="danger">{{ scope.row.itemName }}</el-tag>
                    <span v-else>{{ scope.row.itemName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="变更前" header-align="center" prop="beforeChange" />
                <el-table-column label="变更后" header-align="center" prop="afterChange" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Card, Table, TableColumn, Tag, Select, Option } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

import { getChangeItemDetail } from '@/api/project'
export default {
  name: 'SkyChangeItemDetail',
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    projectId: {
      type: String,
      default: null
    },
    specId: {
      type: String,
      default: null
    }
  },
  data: function() {
    return { contentList: [], relationList: [], loading: true, specName: '' }
  },
  mounted() {
    getChangeItemDetail({ projectId: this.projectId, specId: this.specId })
      .then(res => {
        this.loading = false
        this.specName = res.data.content.specName
        this.contentList = res.data.content.contentList
        this.relationList = res.data.content.relationList
      })
      .catch(e => {
        this.loading = false
        throw e
      })
  },
  methods: {
    changeCellClassName(row, column, rowIndex, columnIndex) {
      if (row.row.change) {
        if (row.columnIndex === 1) {
          return 'cell-before-data'
        }
        if (row.columnIndex === 2) {
          return 'bg-3bb113'
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(change-item-detail) {
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
  .title-tip {
    font-weight: bold;
    color: red;
  }
  .sky-page-content {
    overflow-y: scroll;
    height: 75vh;
  }
  .page-content-loading {
    padding-left: 20px;
    padding-top: 20px;
  }
  .table-detail-content {
    .cell {
      word-break: break-all;
      white-space: break-spaces;
    }
    .cell-before-data {
      .cell {
        text-decoration: line-through;
      }
    }
  }
  .el-table__body-wrapper .full-value-content {
    padding: 0 !important;
  }
  .el-table__body-wrapper .full-value-content .cell {
    padding: 0 !important;
    min-height: 33px !important;
    .full-content {
      width: 100%;
      height: 100%;
    }
  }
  .page-content-item {
    padding-left: 18px;
  }
  .poc-scene-research-content {
    .scene-item {
      .scene-item-name {
        line-height: 28px;
        border-radius: 6px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        padding: 2px 18px;
      }
    }
  }
  .poc-base-detail-content {
    line-height: 28px;
    .base-detail-attr-item div {
      display: inline-block;
    }
    .base-detail-attr-item .attr-label {
      text-align: right;
    }
  }
}
</style>
